import React, { useState } from 'react'

const CollapsibleSection = ({
  title,
  children,
  defaultOpen = false,
  isOpen: controlledIsOpen,
  onToggle,
  icon = null,
  className = ""
}) => {
  const [internalIsOpen, setInternalIsOpen] = useState(defaultOpen)

  const isOpen = controlledIsOpen !== undefined ? controlledIsOpen : internalIsOpen
  const setIsOpen = onToggle || setInternalIsOpen

  return (
    <div className={`border border-white/20 rounded-xl overflow-hidden ${className}`}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-4 bg-white/5 hover:bg-white/10 transition-all duration-200 flex items-center justify-between"
      >
        <div className="flex items-center gap-3">
          {icon && <span className="text-lg">{icon}</span>}
          <h2 className="text-lg font-semibold" style={{color: 'var(--theme-text-primary)'}}>
            {title}
          </h2>
        </div>
        <svg
          className={`w-5 h-5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          style={{color: 'var(--theme-text-secondary)'}}
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="p-6">
          {children}
        </div>
      </div>
    </div>
  )
}

export default CollapsibleSection